import { CardNumberElement } from '@stripe/react-stripe-js';
import React, { Component } from 'react';
import './SellerStripeForm.less'

const SellerStripeFormHOC = OrignalComponent => {
    class NewComponent extends Component {
        constructor(props) {
            super(props)
            this.state = {
                isCardNumberValid: false,
                isExpiryValid: false,
                isCVCValid: false
            }
        }

        changeHandler = async (event) => {
            let { isCVCValid, isCardNumberValid, isExpiryValid } = this.state;
            if (event.elementType == "cardNumber" && !event.error && event.complete) {
                isCardNumberValid = true;
            }
            if (event.elementType == "cardExpiry" && !event.error && event.complete) {
                isExpiryValid = true;
            }
            if (event.elementType == "cardCvc" && !event.error && event.complete) {
                isCVCValid = true;
            }
            this.setState({ isCVCValid, isCardNumberValid, isExpiryValid });

            if (isCVCValid && isCardNumberValid && isExpiryValid) {
                const cardElement = this.props.elements.getElement(CardNumberElement);
                this.props.onChange({ card: cardElement });
            }
            else {
                this.props.onChange({ card: undefined });
            }
        };

        render() {
            return <OrignalComponent {...this.props} changeHandler={this.changeHandler} />
        }
    }
    return NewComponent
}

export default SellerStripeFormHOC;